module.exports = __webpack_public_path__ + "static/media/dashboard.31552ed3.svg";